import React, { useState, useEffect } from 'react';
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	TableContainer,
	TablePagination,
	Tooltip,
	Checkbox,
	Select,
	MenuItem,
	FormControl,
	Button,
	Chip,
} from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import FilterListIcon from '@material-ui/icons/FilterList';
import dayjs from 'dayjs';
import styles from './ManageLotsTable.module.scss';
import SearchBox from '../../../searchBox/SearchBox';
import FilterLot from './filterLot/FilterLot';
import Modal from '../../../layout/modal/Modal';
import CustomButton from '../../../layout/customButton/CustomButton';
import { connect } from 'react-redux';
import { setAlert } from '../../../../redux/alerts/action';

const ManageLotsTable = (props) => {
	const {
		lots,
		availabilityObj,
		closeManageLotsModal,
		openEditLotsModal,
		setEditLotInfo,
		setLotIdArr,
		coBrokers,
		salesAgents,
		setAlert,
	} = props;
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [availability, setAvailability] = useState({});
	const [listOfLots, setListOfLots] = useState([]);
	const [searchField, setSearchField] = useState('');
	const [filteredLots, setFilteredLots] = useState([]);
	const [viewFilterModal, setViewFilterModal] = useState(false);
	const [filteredAvailability, setFilteredAvailability] = useState('');
	const [filteredSalesAgent, setFilteredSalesAgent] = useState('');
	const [filteredSize, setFilteredSize] = useState('');
	const [selected, setSelected] = useState([]);

	useEffect(() => {
		const filtered = listOfLots.filter(
			(lot) =>
				lot['lot']?.toString().includes(searchField) ||
				lot.availability
					.toLowerCase()
					.includes(searchField.toLowerCase()) ||
				(lot?.salesAgent &&
					lot?.salesAgent
						.toLowerCase()
						.includes(searchField.toLowerCase()))
		);
		setFilteredLots(filtered);
	}, [searchField, listOfLots]);

	useEffect(() => {
		let filtered = listOfLots;

		console.log('wekfowf', filtered);
		if (filteredAvailability) {
			filtered = filtered?.filter(
				(lot) => lot.availability === filteredAvailability
			);
		}
		if (filteredSalesAgent) {
			filtered = filtered?.filter(
				(lot) => lot?.assignedSalesAgent === filteredSalesAgent
			);
		}
		if (filteredSize) {
			filtered = filtered?.filter(
				(lot) => lot?.lotSizeType === filteredSize
			);
		}
		setFilteredLots(filtered);
	}, [filteredAvailability, filteredSalesAgent, filteredSize, listOfLots]);

	useEffect(() => {
		setListOfLots(lots);
		setAvailability(availabilityObj);
	}, [lots, availabilityObj]);

	useEffect(() => {
		if (selected.length === 1) {
			setEditLotInfo(lots.filter((lot) => lot.lot === selected[0])[0]);
			setLotIdArr([]);
		} else if (selected.length > 1) {
			setEditLotInfo();
			setLotIdArr(selected);
		} else {
			setEditLotInfo();
			setLotIdArr([]);
		}
	}, [selected, lots]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleSearch = (e) => {
		setSearchField(e.target.value);
	};

	const openEditModal = (e) => {
		if (selected.length === 0) {
			setAlert('warning', 'Please select at least one lot.');
		} else {
			openEditLotsModal();
			closeManageLotsModal();
		}
	};

	const openFilterModal = (e) => {
		setViewFilterModal(true);
	};

	const closeViewFilterModal = () => {
		setViewFilterModal(false);
	};

	const handleDeleteFilteredAvailability = () => {
		setFilteredAvailability('');
	};

	const handleDeleteFilteredSalesAgent = () => {
		setFilteredSalesAgent('');
	};

	const handleDeleteFilteredSize = () => {
		setFilteredSize('');
	};

	const isLotSelected = (name) => selected.indexOf(name) !== -1;

	const handleSelectLots = (event) => {
		if (event.target.checked) {
			const newSelecteds = lots.map((n) => n.lot);
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	};

	const handleSelectLot = (event, lot) => {
		const selectedIndex = selected.indexOf(lot);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, lot);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1)
			);
		}
		setSelected(newSelected);
	};

	const getSalesAgentName = (id) => {
		let salesAgentName = salesAgents.filter(
			(salesAgent) => salesAgent.salesAgentId === id
		)[0]?.salesAgentName;
		return salesAgentName ? salesAgentName : '-';
	};

	const getCoBrokerName = (id) => {
		let coBrokerName = coBrokers.filter(
			(coBroker) => coBroker.coBrokerId === id
		)[0]?.name;
		return coBrokerName ? coBrokerName : '-';
	};

	return (
		<div className={styles.manage_lots}>
			<div className={styles.manage_lots_header}>
				<div>
					<Button
						className={styles.manage_lots_filter}
						startIcon={<FilterListIcon />}
						onClick={openFilterModal}
					>
						Filter
					</Button>
					{filteredAvailability && filteredAvailability !== '' && (
						<Chip
							label={
								filteredAvailability === 'soldout'
									? 'Sold Out'
									: filteredAvailability === 'pending'
									? 'Pending'
									: filteredAvailability === 'available'
									? 'Available'
									: filteredAvailability === 'hold'
									? 'Hold'
									: ''
							}
							variant='outlined'
							size='small'
							className={styles.manage_lots_chip}
							onDelete={handleDeleteFilteredAvailability}
						/>
					)}
					{filteredSalesAgent && filteredSalesAgent !== '' && (
						<Chip
							label={getSalesAgentName(filteredSalesAgent)}
							variant='outlined'
							size='small'
							className={styles.manage_lots_chip}
							onDelete={handleDeleteFilteredSalesAgent}
						/>
					)}
					{filteredSize && filteredSize !== '' && (
						<Chip
							label={filteredSize + "'"}
							variant='outlined'
							size='small'
							className={styles.manage_lots_chip}
							onDelete={handleDeleteFilteredSize}
						/>
					)}
				</div>
				<div className={styles.button_and_search}>
					<CustomButton
						width={102}
						height={42}
						onClick={openEditModal}
					>
						Update
					</CustomButton>
					<Tooltip
						title='Search lots, assigned agents, availabilities...'
						arrow
					>
						<div>
							<SearchBox handleChange={handleSearch} />
						</div>
					</Tooltip>
				</div>
			</div>
			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell padding='checkbox'>
								<Checkbox
									className={styles.lots_list_checkbox}
									checkedIcon={
										<CheckBoxIcon
											className={styles.checkbox}
										/>
									}
									onChange={handleSelectLots}
								/>
							</TableCell>
							<TableCell>Lots</TableCell>
							<TableCell>Availability</TableCell>
							<TableCell>Closing Dates</TableCell>
							<TableCell>Assign Sales Agents</TableCell>
							<TableCell>Assign Co-Broker</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{filteredLots &&
							filteredLots
								.slice(
									page * rowsPerPage,
									page * rowsPerPage + rowsPerPage
								)
								.map((item, index) => {
									const isItemSelected = isLotSelected(
										item.lot
									);

									return (
										<TableRow
											hover
											key={item.lot}
											role='checkbox'
										>
											<TableCell padding='checkbox'>
												<Checkbox
													className={
														styles.lots_list_checkbox
													}
													checkedIcon={
														<CheckBoxIcon
															className={
																styles.checkbox
															}
														/>
													}
													checked={isItemSelected}
													onClick={(event) =>
														handleSelectLot(
															event,
															item.lot
														)
													}
												/>
											</TableCell>
											<TableCell
												component='th'
												scope='row'
											>
												{item.lot}
											</TableCell>
											<TableCell
												component='th'
												scope='row'
											>
												{availability[
													'lot' + item.lot
												] === 'available'
													? 'Available'
													: availability[
															'lot' + item.lot
													  ] === 'pending'
													? 'Pending'
													: availability[
															'lot' + item.lot
													  ] === 'soldout'
													? 'Sold Out'
													: availability[
															'lot' + item.lot
													  ] === 'hold'
													? 'Hold'
													: '-'}
											</TableCell>
											<TableCell
												component='th'
												scope='row'
											>
												{item.closingDate
													? dayjs(
															item.closingDate
													  ).format('DD MMM YY')
													: '-'}
											</TableCell>
											<TableCell
												component='th'
												scope='row'
											>
												{getSalesAgentName(
													item.assignedSalesAgent
												)}
											</TableCell>
											<TableCell
												component='th'
												scope='row'
											>
												{getCoBrokerName(
													item.assignedCoBroker
												)}
											</TableCell>
										</TableRow>
									);
								})}
					</TableBody>
				</Table>
			</TableContainer>
			<TablePagination
				rowsPerPageOptions={[5, 10, 25]}
				component='div'
				count={filteredLots.length}
				rowsPerPage={rowsPerPage}
				page={page}
				onPageChange={handleChangePage}
				onRowsPerPageChange={handleChangeRowsPerPage}
				labelRowsPerPage={
					<div style={{ color: 'var(--text-high-emphasis)' }}>
						Rows per page
					</div>
				}
				nextIconButtonProps={{
					style: {
						padding: '0px',
					},
				}}
				backIconButtonProps={{
					style: {
						padding: '0px',
						marginLeft: '-10px',
					},
				}}
				SelectProps={{
					style: {
						border: '1px solid var(--text-mid-emphasis)',
						borderRadius: '4px',
						padding: '4px',
						marginRight: '10px',
					},
				}}
				//className='tablePagination'
			/>
			<div className={styles.filter_lot_modal}>
				<Modal
					show={viewFilterModal}
					title='Filters'
					close={closeViewFilterModal}
				>
					<FilterLot
						filteredAvailability={filteredAvailability}
						filteredSalesAgent={filteredSalesAgent}
						filteredSize={filteredSize}
						setFilteredAvailability={setFilteredAvailability}
						setFilteredSalesAgent={setFilteredSalesAgent}
						setFilteredSize={setFilteredSize}
						closeModalHandler={closeViewFilterModal}
					/>
				</Modal>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	lots: state.siteplanManagement.lots,
	availabilityObj: state.siteplanManagement.availability,
	coBrokers: state.siteplanManagement.coBrokers,
	salesAgents: state.siteplanManagement.salesAgents,
});

export default connect(mapStateToProps, { setAlert })(ManageLotsTable);
